<script setup>
const props = defineProps({
  navList: {
    type: Array,
    default: () => [],
  },

})
</script>

<template>
  <div class="flex text-sm items-center gap-[4px]">
    <NuxtLink class="cursor-pointer text-textTertiary" :to="localePath('/')">
      TT
    </NuxtLink>

    <svgo-common-arrow-right class="w-4 h-4 rtl:rotate-180" />
    <template v-for="(item, i) in props.navList" :key="i">
      <NuxtLink
        class="text-textTertiary cursor-pointer hover:!text-textPrimary"
        :to="localePath(item.link)"
        :class="[{ '!text-textPrimary font-semibold': i === props.navList.length - 1 }]"
      >
        {{ item.label }}
      </NuxtLink>

      <svgo-common-arrow-right v-if="i !== props.navList.length - 1 " class="w-4 h-4 rtl:rotate-180" />
    </template>
  </div>
</template>
